/** Validated env config — fail-fast on missing/invalid VITE_* vars. */
import { z } from "zod";

const schema = z.object({
  VITE_API_CENTRAL_BASE_URL: z.string().url(),
  VITE_KEYCLOAK_URL: z.string().url(),
  VITE_KEYCLOAK_REALM: z.string().min(1),
  VITE_KEYCLOAK_CLIENT_ID: z.string().min(1),
  VITE_TENANT_ID: z.string().min(1),
  VITE_APP_BASE_URL: z.string().url(),
});

export type ParsedEnv = z.infer<typeof schema>;

const parsed = schema.safeParse(import.meta.env);

if (!parsed.success) {
  throw new Error(
    "Invalid VITE_* environment configuration:\n" +
      JSON.stringify(parsed.error.format(), null, 2),
  );
}

export const env: ParsedEnv = parsed.data;
